import {AxiosError, AxiosResponse, AxiosStatic} from "axios"
import { App } from '@/apps/FavoriteAppsWidget/models/app-viewmodel'

export default (http: AxiosStatic, resource = '/api/userpreferences') => ({
    getAllApps(language: string): Promise<AxiosResponse> {
        return new Promise<AxiosResponse>((resolve, reject) => {
            http
                .get(`${resource}/all-apps?language=${language}`)
                .then((response: AxiosResponse) => {
                    resolve(response)
                })
                .catch((error: AxiosError) => {
                    reject(error.response)
                })
        })
    },
    getFavoriteApps(language: string): Promise<AxiosResponse> {
        return new Promise<AxiosResponse>((resolve, reject) => {
            http
                .get(`${resource}/my-apps?language=${language}`)
                .then((response: AxiosResponse) => {
                    resolve(response)
                })
                .catch((error: AxiosError) => {
                    reject(error.response)
                })
        })
    },
    removeFavoriteApp(data: App): Promise<AxiosResponse> {
        return new Promise<AxiosResponse>((resolve, reject) => {
            http
                .delete(`${resource}/my-apps?id=${data.appId}`)
                .then((response: AxiosResponse) => {
                    resolve(response)
                })
                .catch((error: AxiosError) => {
                    reject(error.response)
                })
        })
    },
    addFavoriteApp(data: App): Promise<AxiosResponse> {
        return new Promise<AxiosResponse>((resolve, reject) => {
            http
                .post(`${resource}/my-apps`, {id: data.appId})
                .then((response: AxiosResponse) => {
                    resolve(response)
                })
                .catch((error: AxiosError) => {
                    reject(error.response)
                })
        })
    },
    getMyPages(): Promise<AxiosResponse> {
        return new Promise<AxiosResponse>((resolve, reject) => {
            http
                .get(`${resource}/my-pages`)
                .then((response: AxiosResponse) => {
                    resolve(response)
                })
                .catch((error: AxiosError) => {
                    reject(error.response)
                })
        })
    },
    removeMyPage(id: string): Promise<AxiosResponse> {
        return new Promise<AxiosResponse>((resolve, reject) => {
            http
                .delete(`${resource}/my-pages?id=${id}`)
                .then((response: AxiosResponse) => {
                    resolve(response)
                })
                .catch((error: AxiosError) => {
                    reject(error.response)
                })
        })
    },
    addMyPage(data:  {url: string, title: string}): Promise<AxiosResponse> {
        return new Promise<AxiosResponse>((resolve, reject) => {
            http
                .post(`${resource}/my-pages`, data)
                .then((response: AxiosResponse) => {
                    resolve(response)
                })
                .catch((error: AxiosError) => {
                    reject(error.response)
                })
        })
    }

})
